import axios from 'axios';

// Set config defaults when creating the instance
export const URL_API = process.env.REACT_APP_API_URL;
// export const URL_API = "http://192.168.1.8:8000/";
export const API = axios.create({
  baseURL: `${URL_API}api/v1/`,
});

export const setAuthToken = (token) => {
  API.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  API.defaults.headers.common["Content-Type"] =
    "application/x-www-form-urlencoded";
  API.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
};

export const generateParams = ({
  limit,
  hal,
  cari,
  gender,
  umur,
  dusun,
  rt,
  rw,
  tgl,
  type,
  jenis,
  pekerjaan,
  th,
  kategori,
  status,
  tahun,
  tanggal,
  role,
  jabatan,
  masa,
  bulan,
  ttd,
  ke,
  paket,
  prov,
  city,
}) => {
  let params = "";
  if (limit) params += `limit=${limit}&`;
  if (hal) params += `page=${hal}&`;
  if (cari) params += `search=${cari}&`;
  if (gender) params += `jenis_kelamin=${gender}&`;
  if (umur) params += `umur=${umur}&`;
  if (dusun) params += `dusun_code=${dusun}&`;
  if (rt) params += `dusun_rt=${rt}&`;
  if (rw) params += `dusun_rw=${rw}&`;
  if (tgl) params += `tgl=${tgl}&`;
  if (type !== undefined && type !== null) params += `type=${type}&`;
  if (jenis) params += `jenis=${jenis}&`;
  if (th) params += `tahun_berangkat=${th}&`;
  if (pekerjaan) params += `pekerjaan_code=${pekerjaan}&`;
  if (kategori) params += `category_code=${kategori}&`;
  if (status) params += `status=${status}&`;
  if (tahun) params += `tahun=${tahun}&`;
  if (bulan) params += `bulan=${bulan}&`;
  if (tanggal) params += `tgl=${tanggal}&`;
  if (role) params += `users_type=${role}&`;
  if (jabatan) params += `jabatan=${jabatan}&`;
  if (masa) params += `masa_jabatan=${masa}&`;
  if (ttd) params += `ttd_atas_nama=${ttd}&`;
  if (paket) params += `paket=${paket}&`;
  if (prov) params += `province_code=${prov}&`;
  if (city) params += `city_code=${city}&`;
  if (ke !== undefined && ke !== null) params += `ke=${ke}&`;
  return params.slice(0, params.length - 1);
};
